export default __webpack_public_path__ + "static/media/climate-litigation-risk.909ae97d.jpg";